// services/uploadService.ts
import { getConfig } from '@cabukaka/config';
import axios from 'axios';

export const uploadService = {
  upload: async (file: File, token: string, bucket?: string, path?: string): Promise<string> => {
    const { apiUrl } = getConfig();
    
    const formData = new FormData();
    formData.append('file', file);
    if (bucket) formData.append('bucket', bucket);
    if (path) formData.append('path', path);

    const response = await axios.post(`${apiUrl}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.url;
  },

  uploadMultiple: async (files: File[], token: string, bucket?: string, path?: string): Promise<string[]> => {
    const { apiUrl } = getConfig();
    
    const uploadPromises = files.map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      if (bucket) formData.append('bucket', bucket);
      if (path) formData.append('path', path);

      const response = await axios.post(`${apiUrl}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      });
      return response.data.url;
    });

    return await Promise.all(uploadPromises);
  },

  delete: async (bucket: string, path: string, token: string): Promise<void> => {
    const { apiUrl } = getConfig();

    await axios.delete(`${apiUrl}/upload`, {
      data: { bucket, path },
      headers: { Authorization: `Bearer ${token}` }
    });
  },

  deleteMultiple: async (files: { bucket: string; path: string }[], token: string): Promise<void> => {
    const { apiUrl } = getConfig();

    const deletePromises = files.map(async (file) => {
      await axios.delete(`${apiUrl}/upload`, {
        data: { bucket: file.bucket, path: file.path },
        headers: { Authorization: `Bearer ${token}` }
      });
    });

    await Promise.all(deletePromises);
  }
};